<template>
  <Layout>
    <Navbar/>
    <Header class="sub-header">
      <h3 style="text-align:center;">Platform Settings</h3>
    </Header>
    <Row :gutter="16">
      <Col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :lg="{ span: 12, offset: 6 }">
      <Form :model="form" label-position="top" style="margin-top:64px;">
        <FormItem label="Origin Server Url">
          <Input v-model="form.originServerUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="Self Service Origin Domain">
          <Input v-model="form.selfServiceOriginDomain" placeholder=""></Input>
        </FormItem>
        <FormItem label="Self Service Origin App">
          <Input v-model="form.selfServiceOriginApp" placeholder=""></Input>
        </FormItem>
        <FormItem label="Slide Data Url">
          <Input v-model="form.slideDataUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="HLS Url">
          <Input v-model="form.hlsUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="RTMP Url">
          <Input v-model="form.rtmpUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="Player Url">
          <Input v-model="form.playerUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="Event Url">
          <Input v-model="form.eventUrl" placeholder=""></Input>
        </FormItem>
        <FormItem label="Embed Url">
          <Input v-model="form.embedUrl" placeholder=""></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="saveAppSettings()" style="float:right;" v-if="!isSaving">Save</Button>
          <Button type="primary" style="float:right;" disable v-if="isSaving">Please wait</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
  </Layout>
</div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapGetters
} from 'vuex';
import Navbar from '@/components/base/Navbar.vue'
export default {
  data() {
    return {
      form: {},
      isSaving: false,
    }
  },
  components: {
    Navbar
  },
  computed: {
    ...mapGetters('appsettings', {
      storeGetAppSettings: 'current'
    }),
  },
  methods: {
    ...mapActions('appsettings', {
      createSettingsAction: 'create',
      patchSettingsAction: 'patch',
    }),
    saveAppSettings() {
      this.$set(this.$data, 'isSaving', true)
      if (this.storeGetAppSettings) {
        this.$store.dispatch('appsettings/patch', [this.$store.state.appsettings.copy._id, this.form, {}]).then((response) => {
          this.$set(this.$data, 'isSaving', false)
          this.$Message.success('Platform settings has been saved')
          //this.$toastr.s('Platform settings has been saved')
        });
      } else {
        this.createSettingsAction(this.form).then((response) => {
          this.$set(this.$data, 'isSaving', false)
          //this.$toastr.s('Platform settings has been saved')
          this.$Message.success('Platform settings has been saved')
          this.$router.replace('new-user')
        })
      }
    }
  },
  watch: {
    storeGetAppSettings: {
      deep: true, // not sure if we need this?
      handler() {
        this.form = _.cloneDeep(this.storeGetAppSettings);
      }
    },
  },
  mounted() {
    if (this.storeGetAppSettings) {
      this.form = _.cloneDeep(this.storeGetAppSettings);
    } else {
      this.form = {}
    }
  },
  created() {}
}
</script>

<style>

</style>
